<template>
  <div>
    <table-top
      page-size-start
      @fetch="fetchTonnage"
    />
    <data-table
      class="my-5"
      :table-header="tonnageHeaders"
      :table-data="tonnageData"
      :sort-by="filter.sort_by"
      :sort-dir="filter.sort_dir"
      @sort="sortTable"
    >
      <template #month="{ row }">
        <span>{{ row.month ? moment(row.month, 'YYYY-MM-DDTHH:mm:ss.SSSZ').format('MMM-YYYY') : '-' }}</span>
      </template>
      <template #itm_coal_tonnage="{ row }">
        <span>{{ row.itm_coal_tonnage ? row.itm_coal_tonnage.toLocaleString('id-ID') : '-' }}</span>
      </template>
      <template #third_party_coal_tonnage="{ row }">
        <span>{{ row.third_party_coal_tonnage ? row.third_party_coal_tonnage.toLocaleString('id-ID') : '-' }}</span>
      </template>
      <template #total_tonnage="{ row }">
        <span>{{ row.total_tonnage ? row.total_tonnage.toLocaleString('id-ID') : '-' }}</span>
      </template>
    </data-table>
    <table-bottom @fetch="fetchTonnage" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import DataTable from '@/components/dataTable'
import TableBottom from '@/components/tableBottom'
import TableTop from '@/components/tableTop'
import downloadUtils from '@/utils/downloadUtils'

export default {
  components: {
    DataTable,
    TableBottom,
    TableTop
  },
  props: {
    dateRange: {
      type: Array,
      default: () => []
    },
    isFetch: {
      type: Boolean,
      default: () => false
    },
    isDownload: {
      type: Boolean,
      default: () => false
    }
  },
  beforeCreate() {
    this.$store.dispatch('Table/resetConfig')
  },
  data() {
    return {
      filter: {
        sort_by: null,
        sort_dir: null
      },
      tonnageHeaders: [
        { key: 'month', label: 'Month', sortable: true },
        { key: 'itm_coal_tonnage', label: 'ITM Coal Tonnage' },
        { key: 'third_party_coal_tonnage', label: '3rd Party Coal Tonnage' },
        { key: 'total_tonnage', label: 'Total Tonnage' },
        { key: 'number_of_barge', label: 'Number Of Barge' },
        { key: 'source', label: 'Source' }
      ],
      tonnageData: []
    }
  },
  computed: {
    ...mapGetters({
      tonnageItems: 'Tonnage/tonnages',
      tonnageFile: 'Tonnage/tonnageFile'
    })
  },
  watch: {
    isFetch: {
      handler(val) {
        if (val) {
          this.fetchTonnage()
        }
      }
    },
    isDownload: {
      handler(val) {
        if (val) {
          this.downloadTonnage()
        }
      }
    },
    tonnageItems: {
      handler(val) {
        this.tonnageData = val
      }
    },
    tonnageFile: {
      handler(val) {
        if (val) {
          downloadUtils(val, `tonnage_plan_${this.dateRange[0]}_${this.dateRange[1]}.xls`)
          this.$store.dispatch('Tonnage/resetFile')
        }
      }
    }
  },
  methods: {
    async fetchTonnage() {
      if (!this.isDateEmpty()) {
        try {
          await this.$store.dispatch('Tonnage/fetchTonnages', {
            start_date: this.moment(this.dateRange[0], 'DD-MMM-YYYY').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
            end_date: this.moment(this.dateRange[1], 'DD-MMM-YYYY').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
            ...this.filter
          })
          this.$emit('update:isFetch', false)
        } catch (err) {
          this.$emit('update:isFetch', false)
          this.showFailedNotification(this, 'Failed to fetch tonnage plan')
        }
        return
      }

      this.$emit('update:isFetch', false)
      this.showWarningNotification(this, 'Please pick date first')
    },
    async downloadTonnage() {
      if (!this.isDateEmpty()) {
        try {
          await this.$store.dispatch('Tonnage/downloadTonnages', {
            start_date: this.moment(this.dateRange[0], 'DD-MMM-YYYY').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
            end_date: this.moment(this.dateRange[1], 'DD-MMM-YYYY').format('YYYY-MM-DDTHH:mm:ss.SSSZ')
          })
          this.$emit('update:isDownload', false)
        } catch (err) {
          this.$emit('update:isDownload', false)
          this.showFailedNotification(this, 'Cannot download excel file, please try again')
        }
        return
      }

      this.$emit('update:isDownload', false)
      this.showWarningNotification(this, 'Please pick date first')
    },
    sortTable(sortBy, sortDir) {
      this.filter.sort_by = sortBy
      this.filter.sort_dir = sortDir

      this.$emit('update:isFetch', true)
      this.fetchTonnage()
    },
    isDateEmpty() {
      return !this.dateRange.length || !this.dateRange[0] || !this.dateRange[1]
    }
  }
}
</script>
